import Mustache from 'mustache';
import { getTranslation } from './utilities';
import ShipmentTrackingClient from './clients/ShipmentTrackingClient';

class AccountShipmentTracking
{
    constructor()
    {
        this.shipmentTrackingClient = new ShipmentTrackingClient();
        this.itemElementTemplate = document.querySelector('#shipmentTrackingItemElementTemplate').innerHTML;
        this.selector = '.js-shipment-tracking';
    }

    init()
    {
        let self = this;

        $(this.selector).DataTable({
            ajax: {
                url: this.shipmentTrackingClient.uri,
                data: function(data)
                {
                    return {
                        skip: data.start,
                        take: data.length,
                        sort: self.formatOrder(self, data.order)// data.order
                    };
                },
                // dataSrc: this.shipmentTrackingClient.dataSrc
                dataSrc: (json) =>
                {
                    for (let i = 0; i < json[this.shipmentTrackingClient.dataSrc].length; i++)
                    {
                        json[this.shipmentTrackingClient.dataSrc][i].invoice
							= this.createInvoiceDocumentLink(
                                json[this.shipmentTrackingClient.dataSrc][i].customerId,
                                json[this.shipmentTrackingClient.dataSrc][i].customerPrivateFileName
                            );

                        json[this.shipmentTrackingClient.dataSrc][i].url
							= this.createShipmentCarrierLink(
                                json[this.shipmentTrackingClient.dataSrc][i].shipmentCarrier,
                                json[this.shipmentTrackingClient.dataSrc][i].trackingCode
                            );
                    }
                    return json[this.shipmentTrackingClient.dataSrc];
                }
            },
            dom:'l\
				f\
				r\
				<"shipment-tracking-table__scroll table--scroll-mobile"t>\
				p\
				i',
            pageLength: 20,
            serverSide: true,
            processing: true,
            searching: false,
            lengthChange: false,
            language: this.datatableTexts(),
            columnDefs: [{
                targets: [0, 1, 2, 3, 4],
                orderable: false
            },
            {
                width: '20%',
                targets: 0,
                orderable: false,
                className: 'shipment-tracking-list__invoice',
                render: function(data, type, row)
                {
                    return Mustache.render(this.itemElementTemplate, {
                        shipmentTrackingList: row,
                        invoiceDocumentIdColumn: true
                    });
                }.bind(this)
            },
            {
                width: '15%',
                targets: 1,
                orderable: false,
                className: 'shipment-tracking-list__shippedon text--center',
                render: function(data, type, row)
                {
                    let shipmentDatetime = new Date(row.shipmentDatetime.toString());

                    row.shipmentDatetime = shipmentDatetime.getDate() + '.'
						+ ('0' + (shipmentDatetime.getMonth() + 1)).slice(-2) + '.'
						+ shipmentDatetime.getFullYear();
                    return Mustache.render(this.itemElementTemplate, {
                        shipmentTrackingList: row,
                        shipmentDatetimeColumn: true
                    });
                }.bind(this)
            },
            {
                width: '15%',
                data: null,
                targets: 2,
                orderable: false,
                className: 'shipment-tracking-list__parcelnumber text--center',
                render: function(data, type, row)
                {
                    let parcelCountLTColumn = true;
                    let parcelCountGTColumn = false;

                    if (row.parcelCount !== 1)
                    {
                        parcelCountLTColumn = false;
                        parcelCountGTColumn = true;
                    }
                    return Mustache.render(this.itemElementTemplate, {
                        shipmentTrackingList: row,
                        parcelCountLTColumn: parcelCountLTColumn,
                        parcelCountGTColumn: parcelCountGTColumn
                    });
                }.bind(this)
            },
            {
                width: '24%',
                targets: 3,
                orderable: false,
                className: 'shipment-tracking-list__trackingnumber text--center',
                render: function(data, type, row)
                {
                    let trackingCodeColumnWithUrl = false;
                    let trackingCodeColumnWithoutUrl = true;

                    if (row.url !== '')
                    {
                        trackingCodeColumnWithUrl = true;
                        trackingCodeColumnWithoutUrl = false;
                    }
                    return Mustache.render(this.itemElementTemplate, {
                        shipmentTrackingList: row,
                        trackingCodeColumnWithUrl: trackingCodeColumnWithUrl,
                        trackingCodeColumnWithoutUrl: trackingCodeColumnWithoutUrl,
                        shipmentTranslation: getTranslation('content.shipmentdetails.track.shipment')
                    });
                }.bind(this)
            },
            {
                width: '25%',
                targets: 4,
                className: 'shipment-tracking-list__shippingaddress',
                orderable: false,
                render: function(data, type, row)
                {
                    return Mustache.render(this.itemElementTemplate, {
                        shipmentTrackingList: row,
                        shippingAddressColumn: true
                    });
                }.bind(this)
            }],
            createdRow: function(row, data)
            {
                let $row = $(row);

                $row.attr('data-shipment-tracking-id', data.id);
            }
        });
    }

    datatableTexts()
    {
        return {
            'paginate': {
                'previous': '<i class="fa-regular fa-chevron-left"></i>',
                'next': '<i class="fa-regular fa-chevron-right"></i>',
            },
            'processing': getTranslation('content.shipmentdetails.processing'),
            'loadingRecords': getTranslation('content.shipmentdetails.loading'),
            'info': getTranslation('content.shipmentdetails.info.entries'),
        };
    }

    formatOrder(self, order)
    {
        $(order).each(function(k)
        {
            order[k].field = self.matchOrderIdWithColumnName(order[k].column);
        });

        return order;
    }

    matchOrderIdWithColumnName(orderId)
    {
        switch (orderId)
        {
        case 0:
            return 'invoiceDocumentId';
        case 1:
            return 'shipmentDatetime';
        case 2:
            return 'parcelCount';
        case 3:
            return 'trackingCode';
        case 4:
            return 'shippingAddress';
        default:
            return null;
        }
    }

    createInvoiceDocumentLink(customerId, customerPrivateFileName)
    {
        let invoice;

        if (customerPrivateFileName)
        {
            invoice = 'assets/private/20/' + customerId + '/' + customerPrivateFileName;
        }
        else
        {
            invoice = '';
        }

        return invoice;
    }

    createShipmentCarrierLink(shipmentCarrier, trackingCode)
    {
        if (shipmentCarrier && trackingCode)
        {
            switch (shipmentCarrier)
            {
            case 'DHL':
                return 'https://nolp.dhl.de/nextt-online-public/set_identcodes.do?idc=' + trackingCode;
            case 'DHLEP':
                return 'https://nolp.dhl.de/nextt-online-public/set_identcodes.do?idc=' + trackingCode;
            case 'DPD':
                return 'https://tracking.dpd.de/parcelstatus?query=' + trackingCode;
            case 'UPS':
                return 'http://wwwapps.ups.com/WebTracking/processInputRequest?TypeOfInquiryNumber=T&InquiryNumber1=' + trackingCode;
            default:
                return '';
            }
        }
    }
}

if (document.querySelector('.js-shipment-tracking') !== null)
{
    (new AccountShipmentTracking()).init();
}
